<template>
  <b-modal
    :id="id"
    title="Detalle de qc"
    :header-bg-variant="data ? getBootstrapColorName(data.color) : ''"
    body-class="p-0"
  >
    <div v-if="Object.keys(data).length === 0">Nada que mostrar</div>
    <div v-else>
      <b-table v-if="ready" stacked :items="[data.data]" :fields="fields"> </b-table>
    </div>
  </b-modal>
</template>

<script>
import { getBootstrapColorName } from "../../../../utils";
import qimaDict from "../../../../lang/APPSHEETQC";
export default {
  name: "ModalQc",
  methods: {
    getBootstrapColorName
  },
  data() {
    return {
      fields: [],
      ready: false
    };
  },
  props: {
    id: {
      type: String,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
    this.fields = Object.keys(qimaDict).map((key) => {
      return {
        key,
        label: qimaDict[key] || key
      };
    });
    this.ready = true;
  }
};
</script>

<style></style>
